import React from 'react';

import { Box, Button, H1, Text } from '@betterment/samba-react';
import { HR, Modal } from '@betterment/style-closet-react';

import { Employer } from '../data';

interface Props {
  employer: Employer;
  closeHandler: () => void;
}

const EmployerContributionDescriptionModal: React.FC<React.PropsWithChildren<Props>> = ({ employer, closeHandler }) => {
  const { shortDescription, longDescription, discretionaryWithTiersDescription } = employer.contributionConfig ?? {};

  return (
    <Modal closeHandler={closeHandler} contentWidth={['100%', '800px']} aria-label="How does vesting work?">
      <Modal.Slot name="content">
        <Box css={{ m: 'space.400' }}>
          <H1 css={{ pb: 'space.300' }} variant="title200">
            Employer match details
          </H1>
          <HR mb="8" />
          <H1 css={{ pb: 'space.100', fontWeight: '400' }} variant="title200">
            {shortDescription}
          </H1>
          <Text css={{ display: 'block', pb: 'space.100', color: 'text.weak' }} variant="text50">
            {longDescription}
          </Text>
          {discretionaryWithTiersDescription && (
            <Text css={{ color: 'text.weak', display: 'block' }} variant="text50">
              {discretionaryWithTiersDescription}
            </Text>
          )}
          {employer.contributionConfig && employer.contributionConfig?.hasVesting && (
            <>
              <H1 css={{ mt: 'space.300', pb: 'space.100', fontWeight: '400' }} variant="title200">
                Your match vests
              </H1>
              <Text css={{ color: 'text.weak' }} variant="text50">
                These matched dollars will become yours over a period of time depending on your company’s plan rules.
                You can check with your employer to determine your company’s specific vesting schedule. All
                contributions that you make to the plan through payroll are owned by you completely. Only employer match
                dollars are subject to vesting.
              </Text>
            </>
          )}
          <Button css={{ mt: 'space.300' }} onClick={closeHandler} variant="solidSecondary">
            Close
          </Button>
        </Box>
      </Modal.Slot>
    </Modal>
  );
};

export default EmployerContributionDescriptionModal;
